import * as React from 'react';
import { DescriptionContainer } from '../containers/DescriptionContainer.js';
import { SolutionContainer } from '../containers/SolutionContainer.js';
import { baseClassName } from '../styles/index.js';

const SolutionPicker = ({ activeSolution , handleClick , isLoading , solutions  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: baseClassName
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${baseClassName}__list`
    }, solutions.map((solution)=>/*#__PURE__*/ React.createElement(SolutionContainer, {
            isChecked: activeSolution ? solution.bundleSku === activeSolution.bundleSku : false,
            isLoading: isLoading,
            key: solution.bundleSku,
            onChange: handleClick,
            solution: solution
        })
    )), /*#__PURE__*/ React.createElement(DescriptionContainer, {
        description: activeSolution === null || activeSolution === void 0 ? void 0 : activeSolution.description
    }));
};

export { SolutionPicker };
//# sourceMappingURL=SolutionPicker.js.map
